import { loadManifest } from '@angular-architects/module-federation';
/*
  Para rodar local descomentar a linha 8 e comentar a linha 10
 */

// const manifest = "/assets/mf.manifest.local.json";

const manifest = "/assets/mf.manifest.json";

loadManifest(manifest)
  .catch(err => console.error(err))
  .then(() => import('./bootstrap'))
  .catch(err => console.error(err));